import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function HomeRedirect() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const isGuest = localStorage.getItem("isGuest") === "true";

  const [products] = useState([
    { name: "Paracetamol 500mg", price: 25 },
    { name: "Dolo 650", price: 30 },
    { name: "Vitamin C", price: 50 },
    { name: "Cough Syrup", price: 90 }
  ]);

  // 🔥 HANDLE PROTECTED NAVIGATION
  const handleProtectedNavigation = (path) => {
    if (user) {
      navigate(path); // logged in → allow
    } else {
      navigate("/"); // not logged in → login page
    }
  };

  return (
    <div style={styles.page}>

      {/* HERO */}
      <div style={styles.hero}>
        <h1>PharmaHelp</h1>
        <p>Your Trusted Online Pharmacy</p>

        <button
          onClick={() => handleProtectedNavigation("/customer-dashboard")}
          style={styles.btn}
        >
          Shop Medicines
        </button>
      </div>

      {/* TRUST */}
      <div style={styles.trust}>
        <span>✔ 100% Genuine Medicines</span>
        <span>🚚 Fast Delivery</span>
        <span>📞 Expert Support</span>
      </div>

      {/* CATEGORIES */}
      <div style={styles.section}>
        <h3>Categories</h3>
        <div style={styles.grid}>
          <div
            style={styles.card}
            onClick={() => handleProtectedNavigation("/customer-dashboard")}
          >
            💊 Medicines
          </div>

          <div
            style={styles.card}
            onClick={() => handleProtectedNavigation("/customer-dashboard")}
          >
            🩺 Surgical
          </div>

          <div
            style={styles.card}
            onClick={() => handleProtectedNavigation("/customer-dashboard")}
          >
            ❤️ Intimate Care
          </div>

          <div
            style={styles.card}
            onClick={() => handleProtectedNavigation("/customer-dashboard")}
          >
            💇 Hair & Skin
          </div>
        </div>
      </div>

      {/* TOP PRODUCTS */}
      <div style={styles.section}>
        <h3>Top Medicines</h3>

        <div style={styles.grid}>
          {products.length === 0 && <p>Loading...</p>}

          {products.map((p, i) => (
            <div key={i} style={styles.productCard}>
              <h4>{p.name}</h4>
              <p>₹{p.price}</p>

              <button
                onClick={() =>
                  handleProtectedNavigation("/customer-dashboard")
                }
              >
                View
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* WHY US */}
      <div style={styles.section}>
        <h3>Why Choose PharmaHelp?</h3>
        <ul>
          <li>✔ Verified Medicines</li>
          <li>✔ Affordable Prices</li>
          <li>✔ Quick Delivery</li>
        </ul>
      </div>

      {/* 🔥 GUEST WARNING */}
      {!user && (
        <div style={styles.warning}>
          Please login to continue shopping 🛒
        </div>
      )}

    </div>
  );
}

const styles = {
  page: {
    fontFamily: "system-ui",
    padding: 16,
    background: "#f5f7fb"
  },

  hero: {
    textAlign: "center",
    padding: 30,
    background: "linear-gradient(135deg,#2e7dff,#1a5edb)",
    color: "#fff",
    borderRadius: 20
  },

  btn: {
    marginTop: 15,
    padding: "10px 20px",
    borderRadius: 10,
    border: "none",
    background: "#fff",
    color: "#2e7dff",
    fontWeight: "bold",
    cursor: "pointer"
  },

  trust: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 20,
    fontSize: 14
  },

  section: {
    marginTop: 25
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: 10
  },

  card: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    textAlign: "center",
    cursor: "pointer"
  },

  productCard: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    textAlign: "center"
  },

  warning: {
    marginTop: 20,
    padding: 12,
    background: "#fff3cd",
    borderRadius: 10,
    textAlign: "center",
    fontSize: 14
  }
};

export default HomeRedirect;